import { QueryClient } from '@tanstack/react-query';
import { extractApiError } from '@/services/apiClient';

/**
 * Shared TanStack Query client.
 *
 * - Stale-time defaults to 60s — most public reads (events, announcements,
 *   prayer times) tolerate this and it cuts request volume substantially.
 * - 401s are auto-handled by the apiClient interceptor (silent refresh);
 *   when refresh ultimately fails the query returns the error and the
 *   AuthContext clears.
 * - 4xx errors don't retry; transient 5xx errors retry twice.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        const apiError = extractApiError(error);
        if (apiError && apiError.status >= 400 && apiError.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
